// extracted by mini-css-extract-plugin
module.exports = {"shortCuts":"ShortCuts_shortCuts__o_QXG","shortCut":"ShortCuts_shortCut__VK8DF","mutedTextSection":"ShortCuts_mutedTextSection__BaByZ"};